import { Divider, Form, InputNumber, Progress, Spin } from "antd";
import React, { useRef } from "react";
import { useSelector } from "react-redux";
import svg86 from "../../../assets/svg/svg86.svg";
import svg87 from "../../../assets/svg/svg87.svg";
import svg75 from "../../../assets/svg/svg75.svg";
import svg76 from "../../../assets/svg/svg76.svg";
import svg77 from "../../../assets/svg/svg77.svg";
import svg78 from "../../../assets/svg/svg78.svg";
import svg79 from "../../../assets/svg/svg79.svg";
import svg88 from "../../../assets/svg/svg88.svg";
import { cashConverter } from "../../../utils";

const items = [
  {
    svg: svg75,
    title: "Expanded Farmer Led Irrigation Development",
    subTitle:
      "Farmer-Led Irrigation Development expansion targeting smallholder farmers",
    budgetData: [
      { label: "Total Budget:", value: "KSh 85.5bn", align: "right" },
      { label: "Total Acres", value: "75,000", align: "right" },
      { label: "New Expansion", value: "45,000", align: "right" },
      { label: "Optimised", value: "30,000", align: "right" },
    ],
    progressData: {
      labels: { left: "Govt Share", right: "Private Share" },
      bars: [
        { percent: 60, color: "#00C853", label: "60%" },
        { percent: 40, color: "#0092CC", label: "40%" },
      ],
    },
  },
  {
    svg: svg76,
    title: "High-Performing Public Schemes",
    subTitle:
      "Optimization and expansion of existing public irrigation infrastructure",
    budgetData: [
      { label: "Total Budget:", value: "KSh 120bn", align: "right" },
      { label: "Total Acres", value: "120,000", align: "right" },
      { label: "New Expansion", value: "35,000", align: "right" },
      { label: "Optimised", value: "85,000", align: "right" },
    ],
    progressData: {
      labels: { left: "Govt Share", right: "Private Share" },
      bars: [
        { percent: 75, color: "#00C853", label: "75%" },
        { percent: 25, color: "#0092CC", label: "25%" },
      ],
    },
  },
  {
    svg: svg77,
    title: "Enabled Corporate Irrigation",
    subTitle: "Private-sector led large-scale irrigation development",
    budgetData: [
      { label: "Total Budget:", value: "KSh 95bn", align: "right" },
      { label: "Total Acres", value: "80,000", align: "right" },
      { label: "New Expansion", value: "60,000", align: "right" },
      { label: "Optimised", value: "20,000", align: "right" },
    ],
    progressData: {
      labels: { left: "Govt Share", right: "Private Share" },
      bars: [
        { percent: 65, color: "#00C853", label: "65%" },
        { percent: 35, color: "#0092CC", label: "35%" },
      ],
    },
  },
  {
    svg: svg78,
    title: "Revitalized ASAL Irrigation",
    subTitle: "Arid and Semi-Arid Lands Irrigation development for resilience",
    budgetData: [
      { label: "Total Budget:", value: "KSh 75bn", align: "right" },
      { label: "Total Acres", value: "70,000", align: "right" },
      { label: "New Expansion", value: "28,000", align: "right" },
      { label: "Optimised", value: "42,000", align: "right" },
    ],
    progressData: {
      labels: { left: "Govt Share", right: "Private Share" },
      bars: [
        { percent: 70, color: "#00C853", label: "70%" },
        { percent: 30, color: "#0092CC", label: "30%" },
      ],
    },
  },
  {
    svg: svg79,
    title: "Maximized Community Scheme Benefits",
    subTitle:
      "Enhancing for effective management of irrigation systems to bolster food security.",
    budgetData: [
      { label: "Total Budget:", value: "KSh 65bn", align: "right" },
      { label: "Total Acres", value: "70,000", align: "right" },
      { label: "New Expansion", value: "32,000", align: "right" },
      { label: "Optimised", value: "38,000", align: "right" },
    ],
    progressData: {
      labels: { left: "Govt Share", right: "Private Share" },
      bars: [
        { percent: 35, color: "#00C853", label: "35%" },
        { percent: 65, color: "#0092CC", label: "65%" },
      ],
    },
  },
];
function PathwayList({ handleNext, handleBack }) {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const { saving } = useSelector((state) => state.save);
  const { activeObj } = useSelector((state) => state.obj);
  const handleSubmit = async (data) => {
    await handleNext();
  };

  return (
    <div>
      <div className="flex flex-col lg:px-[5rem] px-3">
        <div className="text-[#1A1A1A] font-sora text-[1.25rem] font-[400] leading-[1.5rem]   w-full lg:mb-[2.5rem] mb-[1rem] items-center text-center justify-center">
          Select a NISIP Pathway to Analyze
        </div>

        <div className="mt-[1rem] bg-[#F1F3F5] py-[.88rem]">
          <div className="flex flex-col items-center justify-center">
            <div className="text-[#1A1A1A] text-[.75rem] font-sora font-[400]">
              Investment Amount:
            </div>
            <div className="text-[#0092CC] mt-[1.75rem] text-[1rem] font-[600]">
              {cashConverter(activeObj?.invAmount)}
            </div>
          </div>
        </div>

        <div className="lg:mt-[2.5rem] mt-[1rem] grid lg:grid-cols-3 grid-cols-1 gap-[2.5rem]">
          {items &&
            items?.map((item) => (
              <div className="border border-[#0092CC] bg-white rounded-[.75rem] p-[1.25rem]">
                <div className="w-[4.0625rem] h-[4.0625rem] flex items-center justify-center bg-[#F1F3F5]">
                  <img src={item?.svg} alt={item?.svg} />
                </div>

                <div className="mt-[1.5rem] text-[#050505] text-[1.125rem] font-[400] ">
                  {item?.title}
                </div>
                <div className="mt-[1.5rem] text-[#706F6F] font-[400] text-[.875rem]">
                  {item?.subTitle}
                </div>
                <div className="mt-[1.5rem]">
                  <Divider className="bg-[#D6E1F5]" />
                </div>

                <div className="mt-[1rem]">
                  {item?.budgetData?.map((budget, index) => (
                    <div
                      key={index}
                      className="flex justify-between text-[#424242] text-[.75rem] font-[400] font-sora mb-[0.5rem]"
                    >
                      <div>{budget.label}</div>
                      <div className="font-[600]">{budget.value}</div>
                    </div>
                  ))}

                  <div className="flex justify-between text-[#424242] text-[.75rem] font-[400] font-sora mb-[0.5rem] mt-[1.5rem]">
                    <div>{item?.progressData?.labels?.left}</div>
                    <div>{item?.progressData?.labels?.right}</div>
                  </div>

                  <div className="mt-[0.5rem]">
                    <div className="flex h-[.5rem]">
                      {item?.progressData?.bars?.map((progress, index) => (
                        <div
                          key={index}
                          style={{
                            width: `${progress.percent}%`,
                            backgroundColor: progress.color,
                          }}
                        />
                      ))}
                    </div>
                    <div className="flex justify-between mt-[0.5rem] text-[.75rem] font-[600] text-[#424242]">
                      {item?.progressData?.bars?.map((progress, index) => (
                        <div
                          style={{
                            color: progress?.color,
                          }}
                          key={index}
                        >
                          {progress?.label}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                <button
                  onClick={handleSubmit}
                  className="cstm-btn-2 mt-[1.5rem]"
                  type="button"
                >
                  Select <img src={svg87} alt="svg87" />
                </button>
              </div>
            ))}
        </div>

        <div className="sticky lg:mb-[6.25rem] mb-[3rem] left-0 w-full lg:mt-[3.75rem] mt-[1rem] ">
          <Divider />
          <div className="flex justify-between items-center mt-[1rem] gap-x-[1.25rem]">
            <button
              onClick={handleBack}
              type="button"
              key="back"
              className="flex items-center gap-[1rem]"
            >
              <img src={svg88} alt="svg88" /> Previous
            </button>

            <div className="w-[100px]">
              <button
                onClick={handleSubmit}
                disabled={saving}
                type="button"
                className="cstm-btn-2"
              >
                {saving ? (
                  <Spin />
                ) : (
                  <>
                    Continue <img src={svg87} alt="svg87" />
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PathwayList;
